module.exports = __webpack_public_path__ + "img/ind1.c2590359.png";